import { render, staticRenderFns } from "./BookingTest.vue?vue&type=template&id=2ba10652&lang=html&"
import script from "./BookingTest.vue?vue&type=script&lang=js&"
export * from "./BookingTest.vue?vue&type=script&lang=js&"
import style0 from "./BookingTest.vue?vue&type=style&index=0&id=2ba10652&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports